import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { servicesView } from '../../actions/services'
import { exchangeGuest, exchangeInfo, exchangeMins } from '../../actions/client'
import ExchangeForm from '../../components/Lk/ExchangeForm'
import { setCurrentExchangeStep } from '../../actions/exchange'
import LKModals from '../LK/LKModals'
import RatesBreadcrumbs from '../../components/Rates/RatesBreadcrumps'
import { validateSHA256Hash } from '../../tools/tools'
import LinkC from '../../components/common/LinkC'
import { checkAvailableConstructor } from '../../actions/activation'

class GuestService extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ...GuestService.prepareState(props),
            phoneNumber: '',
            maxMinutes: 0,
            rate: 10.24,
            verifyCode: '',
            queryId: '',
            receivedHash: '',
            attempts: null,
            codeError: false,
            isCorrect: true,
            phoneNumberStatus: null,
            exchangeDisabled: false,
            timeExchange: 0,
            isAvailable: true,
        }
    }
    static prepareState = (props) => {
        let service = true;
        const region = props.regions.selected.alias;
        return {
            breadcrumbs: service ? [
                {
                    url: `/${region}/services`,
                    title: 'Услуги'
                },
                {
                    url: `/${region}/services/services`,
                    title: 'Сервисы'
                },
                {
                    title: 'Обмен минут на ГБ'
                }
            ] : null
        }
    }

    static contextTypes = {
        selectedRegion: PropTypes.object,
        fetchBefore: PropTypes.func,
        pushHistory: PropTypes.func,
    };

    componentDidMount() {

        const exchangeData = localStorage.getItem('exchange-number')?JSON.parse(localStorage.getItem('exchange-number')):null;
        const currentDate = new Date();
        const saveDate = exchangeData?new Date(exchangeData.time):0;
        const diffInSeconds = Math.floor((currentDate - saveDate) / 1000);

        this.setState({
            attempts: localStorage.getItem('attempts')
                ? parseInt(localStorage.getItem('attempts')) : 0,
            timeExchange: saveDate,
            exchangeDisabled: 300-diffInSeconds>0
        })

        if(300-diffInSeconds<0){
            localStorage.removeItem('exchange-number')
        }
    }

    componentDidUpdate(prevProps, prevState) {

        const {isGuest} = this.props.client;
        const {username} = this.props.clientInfo;
        const exchangePhoneNumber = localStorage.getItem('exchange-number')?JSON.parse(localStorage.getItem('exchange-number')):null;
        const secondsExchange = localStorage.getItem('secondsExchange');
        const currentDate = new Date();
        const saveDate = exchangePhoneNumber!==null?exchangePhoneNumber.time:0;

        const diffInSeconds = Math.floor((currentDate - saveDate) / 1000);


        if(!isGuest && (JSON.stringify(prevProps.clientInfo)!==JSON.stringify(this.props.clientInfo)) && username){
            this.props.exchangeInfo(username);
        }

        if(isGuest && (JSON.stringify(prevProps.exchangeState)!==JSON.stringify(this.props.exchangeState))){
            if(this.props.exchangeState && prevProps.currentStep===1){
                this.props.setCurrentStep(2)
            }
        }


        if(exchangePhoneNumber && (300-diffInSeconds>0) && !this.state.exchangeDisabled){
            this.setState({exchangeDisabled: true})
        }


        if(!prevProps.client.exchangeMinsSuccess && this.props.client.exchangeMinsSuccess){

            this.setState({timeExchange: new Date()})
            localStorage.setItem('exchange-number', JSON.stringify({
                phoneNumber: prevState.phoneNumber,
                time: new Date(),
                isGuest: isGuest
            }));

            if(this.state.modal!=='exchange-success'){
                this.props.setCurrentStep(1);
                this.setState({modal: "exchange-success", phoneNumber: '', verifyCode: '', exchangeDisabled: true})
            }
        }



        if (prevProps.exchangeState !== this.props.exchangeState) {

            if (this.props.exchangeState) {

                this.setState({
                    maxMinutes: this.props.exchangeState.max_minutes,
                    rate: this.props.exchangeState.rate,
                    receivedHash: this.props.exchangeState.verify_code_hash,
                    queryId: this.props.exchangeState.query_id
                })
            }
        }

        if(JSON.stringify(prevProps.client && prevProps.client.exchangeInfo)!==JSON.stringify(this.props.client && this.props.client.exchangeInfo)){
            if(!this.props.client.exchangeInfo.available){
                this.props.setCurrentStep(1);
                this.setState({isAvailable: false})
            }else{
                this.setState({isAvailable: true});
            }
        }

        if(this.props.exchangeStateError !== prevProps.exchangeStateError && this.props.exchangeStateError){
            const {message, code} = this.props.exchangeStateError;

            if(message.toLowerCase().match('не принадлежит мотив')){
                this.setState({ phoneNumberStatus: 3003 })
                this.props.setCurrentStep(1);
            }else{
                this.setState({ phoneNumberStatus: code })
                this.props.setCurrentStep(1);
            }
        }

        if(this.props.exchangeStateError !== prevProps.exchangeStateError && !this.props.exchangeStateError){
            this.setState({ phoneNumberStatus: 0 })
        }

        if (prevProps.activation !== this.props.activation) {
            if (this.props.activation.available.message) {
                this.setState({ phoneNumberStatus: 3003 })
                return
            }
            if (!this.props.activation.available.message && !this.props.activation.inProgress) {

                this.setState({ phoneNumberStatus: this.props.activation.mnp.statusCode })
                this.handleExchangeInfo()
            }
        }

        if (prevState.attempts !== this.state.attempts) {
            localStorage.setItem('attempts', this.state.attempts)
        }

        if (this.state.attempts === 3 && !this.state.codeError) {
            this.setState({ codeError: true });
            // this.props.setCurrentStep(2);
        }

        if (prevState.verifyCode !== this.state.verifyCode && this.state.verifyCode.length === 6 && this.state.receivedHash) {
            validateSHA256Hash(this.state.verifyCode, this.state.receivedHash).then(isValid => {
                if (isValid) {
                    localStorage.setItem('attempts', 0)
                    this.props.setCurrentStep(3)
                } else {
                    this.setState({ isCorrect: false })
                }
            })
        }
    }

    handleInputChange = (e) => {
        this.setState({ phoneNumber: e.target.value })
    };

    handleCodeInputChange = (e) => {
        this.setState({ verifyCode: e.target.value })
    }

    operatorCheck = () => {
        // this.props.checkAvailableConstructor(this.state.phoneNumber, this.context.selectedRegion.id)

        let data = {
            phone: this.state.phoneNumber.replace(/\D/gim, '')
        };
        this.setState({ phoneNumber: data.phone.slice(1) })
        this.handleExchangeInfo()
    }

    handleExchangeInfo = () => {
        this.setState({ verifyCode: '', isCorrect: true })
        const regex = /^\d{10}$/;
        let phone;

        if (this.state.phoneNumber && this.state.attempts != 3) {
            if(regex.test(this.state.phoneNumber)){
                phone=this.state.phoneNumber;
            }else{
                phone = this.state.phoneNumber.replace(/\D/gim, '').slice(1);
            }
            this.setState(prevState => ({ attempts: prevState.attempts + 1 }))
            this.props.exchangeInfo(phone)

            return
        }
    };

    onCodeErrorTimeLeft = () => {
        this.setState({ codeError: false, attempts: 0 })

    }

    static getDerivedStateFromProps(props, state) {

        if (!state.service && props.services.length) {
            return { ...state, ...GuestService.prepareState(props) }
        }

        if (props.client.exchangeMinsSuccess) {
            props.setCurrentStep(1);
            return { ...state, modal: "exchange-success", phoneNumber: '', verifyCode: '', exchangeDisabled: true }
        }
        if (props.client.exchangeMinsError) {
            return { ...state, modal: "exchange-error" }
        }
    }


    render() {

        const { breadcrumbs, modal, verifyCode, phoneNumberStatus } = this.state;
        const { formsSettings, isGuest } = this.props.client;
        const { inProgress } = this.props.activation
        const parts = formsSettings && formsSettings.exchange_form ? formsSettings.exchange_form.exchange_form_description.split('1 минута = {{rate}} Мб'):[];


        return (
            <main className="page__main-holder page__main-holder_service" role="main" >
                <div className="b-service-inner b-service-inner_adapt_default">

                    <div className="b-service-inner__service-header b-service-inner__service-header--mob">
                        <div className="b-inner-intro b-inner-intro_adapt_default">
                            <div className="b-inner-intro__wrapper exchange_wrapper">
                                <div className="b-inner-intro__inner page__container">
                                    <div className="b-inner-intro__header" />
                                    <div className={`b-inner-intro__main-area dop-size obmen-minut-inner`} >
                                        <div className="b-inner-intro__main-area-wrapper">
                                            <RatesBreadcrumbs items={breadcrumbs} />
                                            <h1 className="b-inner-intro__title">Обмен минут на ГБ</h1>
                                            {formsSettings.exchange_form ? <div className="b-inner-intro__text">
                                                <span>{parts.length?parts[0]:''}</span>
                                                <span style={{color: '#f37021'}} className='rate_span'>1 мин = {this.state.rate}</span>
                                                <span style={{color: '#f37021'}}>{parts.length?parts[1]:''} Мб</span>
                                            </div> : null}
                                            <div className="b-inner-intro__btn">
                                                <LinkC to={'/services/' + 'obmen-minut-na-gb'}>Подробная информация</LinkC>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="page__container">
                        <div className={'b-service-inner__content-area_top'}>
                            <ExchangeForm max={this.state.maxMinutes}
                                // notice={formsSettings.exchange_form ? formsSettings.exchange_form.exchange_form_description.replace('{{rate}}', clientInfo.exchange.rate) : ""}
                                rate={this.state.rate}
                                timeExchange={this.state.timeExchange}
                                resetExchangeTimer={()=>this.setState({exchangeDisabled: false, timeExchange:0})}
                                exchangeDisabled={this.state.exchangeDisabled}
                                title={false}
                                isAvailable={this.state.isAvailable}
                                client={this.props.clientInfo}
                                isSuccess={this.props.client.exchangeMinsSuccess}
                                onSubmit={this.props.exchangeMinsSend}
                                isGuest={isGuest}
                                phoneNumber={this.state.phoneNumber}
                                onInputChange={this.handleInputChange}
                                sendNumberInfo={this.handleExchangeInfo}
                                step={this.props.currentStep}
                                verifyCode={verifyCode}
                                onCodeChange={this.handleCodeInputChange}
                                codeError={this.state.codeError}
                                exchangeStateError={this.props.exchangeStateError}
                                query={this.state.queryId}
                                setCodeError={this.onCodeErrorTimeLeft}
                                isCorrect={this.state.isCorrect}
                                check={this.operatorCheck}
                                phoneNumberStatus={phoneNumberStatus}
                                inProgress={inProgress}
                            />
                        </div>
                    </div>
                </div>
                <LKModals modal={modal} close={() => { this.setState({ modal: null }) }} />
            </main>
        )
    }
}

export default connect(
    (state) => ({
        services: state.services.servicesLists,
        client: state.client,
        clientInfo: state.client.clientInfo,
        exchange: state.client.clientInfo.exchange,
        regions: state.regions,
        exchangeState: state.client.exchangeInfo && state.client.exchangeInfo.response ? state.client.exchangeInfo.response : state.client.exchangeInfo,
        exchangeStateError: state.client.exchangeInfoError,
        currentStep: state.exchangeSteps.currentStep,
        activation: state.activation,

    }),
    (dispatch) => {
        return {
            getService: (slug, regionId) => dispatch(servicesView(slug, regionId)),
            getExchangeMins: (regionId) => dispatch(exchangeMins(regionId)),
            exchangeMinsSend: (data) => dispatch(exchangeGuest(data)),
            exchangeInfo: (msisdn) => dispatch(exchangeInfo(msisdn)),
            setCurrentStep: (step) => dispatch(setCurrentExchangeStep(step)),
            checkAvailableConstructor: (phone, regionId) => dispatch(checkAvailableConstructor(phone, regionId)),
        }
    }
)(GuestService)
